// extracted by mini-css-extract-plugin
export default {"rating":"CB-z","numberOfStars":"DB-z","count":"EB-z","barGraphSpacing":"FB-z","barGraph":"GB-z"};